import React from "react";
import { Link } from "react-router-dom";
import moment from "moment-timezone";
import Tooltip from "@mui/material/Tooltip";

import currencyFormatter from "../../helpers/currencyFormatter";
import shortenName from "../../helpers/shorten-name";
import formatPaymentType from "../../helpers/format-payment-type";

const getPaymentsColumns = (type) => [
  {
    name: "Payment Date",
    selector: "paymentDate",
    sortable: true,
    cell: (row) => {
      return row.paymentDate ? moment(row.paymentDate).format("M/D/YY") : '-';
    },
    width: "80px",
  },
  {
    name: "Trip #",
    selector: "tripTag",
    sortable: true,
    cell: (row) => {
      return (
        <Link className="ellipsis-cell" to={`/trips/${row.tripId}?tab=${type}`} target="_blank" rel="noopener noreferrer">
          <Tooltip title={row.tripTag} arrow>
            {row.tripTag}
          </Tooltip>
        </Link>
      );
    },
    width: "80px",
  },
  type === "clientPaymentHistory" ? {
    name: "Client",
    selector: "clientName",
    sortable: true,
    wrap: true,
    width: "auto",
    cell: (row) => {
      return <div className="two-line-content">{row.clientName}</div>;
    },
  } : {
    name: "Operator",
    selector: "operator",
    sortable: true,
    wrap: true,
    width: "auto",
    cell: (row) => {
      return <div className="two-line-content">{row.operator}</div>;
    },
  },
  {
    name: "Amount",
    selector: "amount",
    sortable: true,
    cell: (row) => {
      if (
        row?.amount &&
        !isNaN(row?.amount)
      ) {
        return currencyFormatter.format(row.amount);
      }

      return "-";
    },
    minWidth: "120px",
    maxWidth: "140px",
  },
  {
    name: "Type",
    selector: "paymentType",
    sortable: true,
    cell: (row) => {
      return formatPaymentType(row.paymentType);
    },
    minWidth: "80px",
    maxWidth: "110px",
  },
  {
    name: "Entered By",
    selector: "enteredBy",
    sortable: true,
    wrap: true,
    minWidth: "100px",
    maxWidth: "130px",
    cell: (row) => shortenName(row.enteredBy),
  },
];

const clientPaymentsColumns = getPaymentsColumns("clientPaymentHistory");
const operatorPaymentsColumns = getPaymentsColumns("operatorPaymentHistory");

export { clientPaymentsColumns, operatorPaymentsColumns };
